import React from 'react';
import { Navigate } from 'react-router-dom';
import { AdminDomains } from "components/Admin/Domains";
import { AdminSettings } from "components/Admin/Settings";
import { GptResearcher } from "components/GptResearcher";
import { AdminUsers } from "components/Admin/Users";

export const protectedUserRoutes = [
    { path: '/', element: <GptResearcher/> },
    { path: '*', element: <Navigate to="/"/> },
];

export const protectedAdminRoutes = [
    { path: '/admin/domains', element: <AdminDomains/> },
    { path: '/admin/settings', element: <AdminSettings/> },
    { path: '/admin/users', element: <AdminUsers/> },
    { path: '/admin/*', element: <Navigate to="/admin/domains"/> },
];
